/* eslint-disable */
// import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import requestRaw from '@/utils/requestRaw'
import { APIReportPHP, APICoreV2 } from '@/utils/servicesApi'
const qs = require('qs')

export function storedIsEnable(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/status/stored_is_enable',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function storedSetTime(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/status/stored_set_time',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailStatus(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/status/detail',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function actionPublish(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/publish_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDelete(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function actionDraft(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/draft_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function stored(data) {
    return requestRaw({
        url: APICoreV2() + '/birthday-greetings/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function detailForEdit(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteData(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function detail(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updatePublish(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function list(params) {
    return requestDev({
        url: APIReportPHP() + '/birthday-greetings/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/birthdayGreetings.js